import { ViewMode } from "@/components/common/ViewToggle";
import { JobOffersList } from "@/components/jobs/JobOffersList";
import { JobData } from "@/hooks/jobs/useJobsData";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface JobsContentProps {
  jobs: JobData[];
  isLoading: boolean;
  viewMode: ViewMode;
  onRefresh?: () => void;
  refreshInterval?: number;
  enableAutoRefresh?: boolean;
}

export const JobsContent = ({ 
  jobs, 
  isLoading, 
  viewMode, 
  onRefresh,
  refreshInterval = 30000, // Default refresh every 30 seconds
  enableAutoRefresh = false // Disable auto-refresh by default
}: JobsContentProps) => {
  const { t } = useTranslation();
  
  // Set up automatic refresh interval only when explicitly enabled
  useEffect(() => {
    if (!onRefresh || !enableAutoRefresh) return;
    
    // Initial refresh
    onRefresh();
    
    // Set up interval for periodic refreshes
    const interval = setInterval(() => {
      onRefresh();
    }, refreshInterval);
    
    // Clean up on unmount
    return () => clearInterval(interval);
  }, [onRefresh, refreshInterval, enableAutoRefresh]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-48">
        <p>{t("jobs.loading", "Loading job offers...")}</p>
      </div>
    );
  }
  
  return (
    <div className="w-full overflow-hidden">
      <JobOffersList 
        jobs={jobs} 
        viewMode={viewMode}
      />
    </div>
  );
};
